interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  // cancelText?: string; // removido; sin botón cancelar
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonClassName?: string;
  extraActions?: Array<{ label: string; onClick: () => void; className?: string }>;
}

export default function ConfirmModal({
  isOpen,
  title = 'Confirmar acción',
  message,
  confirmText = 'Confirmar',
  // cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  confirmButtonClassName,
  extraActions = [],
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-lg border border-gray-100 overflow-hidden">
        <div className="bg-gradient-to-r from-[#22B6B2]/10 to-[#2C4358]/10 p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-[#22B6B2]/20 flex items-center justify-center text-[#22B6B2] text-2xl">🛈</div>
            <div>
              <h3 className="text-lg font-bold text-[#2C4358]">{title}</h3>
              <p className="text-sm text-[#2C4358]/70">Elige una opción para continuar</p>
            </div>
          </div>
        </div>
        <div className="p-6">
          <div className="text-[#2C4358] text-sm leading-relaxed">{message}</div>
        </div>
        {(() => {
          const hasTwoExtras = (extraActions?.length || 0) > 1;
          const gridCols = hasTwoExtras ? 'sm:grid-cols-3' : 'sm:grid-cols-1';
          return (
            <div className={`px-6 py-4 bg-gray-50 border-t border-gray-200`}>
              <div className={`grid grid-cols-1 ${gridCols} gap-2 w-full`}>
                {(extraActions || []).map((action, idx) => (
                  <button
                    key={`extra-${idx}`}
                    type="button"
                    onClick={action.onClick}
                    className={`h-24 w-full px-3 py-2 rounded-xl font-semibold text-sm whitespace-normal leading-snug inline-flex items-center justify-center text-center ${action.className || 'bg-red-50 text-red-700 border border-red-200 hover:bg-red-100'}`}
                  >
                    {action.label}
                  </button>
                ))}
                <button
                  type="button"
                  onClick={onConfirm}
                  className={`${confirmButtonClassName || 'bg-gradient-to-r from-[#22B6B2] to-[#2C4358] text-white'} h-24 w-full px-4 py-2 rounded-xl font-semibold hover:opacity-95 whitespace-normal leading-snug inline-flex items-center justify-center text-center`}
                >
                  {confirmText}
                </button>
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
}


